import React from "react";
import { v1 as uuidv1 } from "uuid";
const TabcordionLinks = ({ componentTitle, tab }) => {
	const tabcordionTitle = tab.linkSections || undefined;

	return (
		<div className={tabcordionTitle.length > 0 ? "tabcordion--links" : ""}>
			{tabcordionTitle
				? tabcordionTitle.map((link) => (
						<div key={uuidv1()} className="tabcordion--links-body">
							<p className="tabcordion--links-title t-label-sm-heavy">{link.linkLabel}</p>
							<ul className="tabcordion--links-section">
								{(link.links || []).map((item) => {
									return (
										<li key={uuidv1()} className={`tabcordion--links-link t-body-sm`}>
											<a
												href={item.url}
												target={item.target}
												data-a-evt="Link Click"
												data-a-comp={componentTitle + " Tabcordion"}
												data-a-name={item.title}
											>
												{item.title}
											</a>
										</li>
									);
								})}
							</ul>
						</div>
					))
				: null}
		</div>
	);
};

export default TabcordionLinks;
